import { STTextVerticalType } from '@tencent/slide-sdk-model';
import { TextDirectionType } from '@src/slide/domain/ui-model/element-modeles/property/text/constants/text-style-type';

// 文字方向 - sdk对上层类型映射
export const VERTICAL_TYPE_MAP = new Map([
    [STTextVerticalType?.vert, TextDirectionType.ROTATE_90],
    [STTextVerticalType?.vert270, TextDirectionType.ROTATE_270],
    [STTextVerticalType?.wordArtVertRtl, TextDirectionType.WORD_ART_VERTICAL_RTL],
    [STTextVerticalType?.wordArtVert, TextDirectionType.WORD_ART_VERTICAL_LTR],
    [STTextVerticalType?.eaVert, TextDirectionType.VERTICAL],
    [STTextVerticalType?.horz, TextDirectionType.HORIZONTAL],
    // 下面使用TextDirectionType.HORIZONTAL兜底会导致ui2sdk 转换有问题，将horizontal转成mongolianVert，先注释掉
    // [STTextVerticalType?.mongolianVert, TextDirectionType.HORIZONTAL, // 目前office和外卖都不支持编辑，降级到横排
]);
